
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-hire/didi",
      function () {
        return require("private-next-pages/private-hire/didi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-hire/didi"])
      });
    }
  